import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AuthorisedSideNavService} from '../services/authorised-side-nav.service';
import {AuthenticateService} from '../../../services/authenticate.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-authorised-top-nav',
    templateUrl: './authorised-top-nav.component.html',
    styleUrls: ['./authorised-top-nav.component.css']
})
export class AuthorisedTopNavComponent implements OnInit {
    public currentUser: any = {};
    tfa: any = {};
    tfaUser: any = {};
    errorMessage = '';
    errorMessageDisable = '';
    authcode = '';
    onlyAuthCode = '';
    @ViewChild('openAuthModal') openAuthModal: ElementRef;
    @ViewChild('tfaAuthCodeModal') tfaAuthCodeModal: ElementRef;
    @ViewChild('email') email: ElementRef;
    @ViewChild('password') password: ElementRef;

    constructor(private sideNavService: AuthorisedSideNavService,
                private authenticateService: AuthenticateService,
                private router: Router) {
    }

    ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem('user'));
    }

    logoutAdmin() {
        this.authenticateService.logout().subscribe(res => {
            this.router.navigateByUrl('login');
        });
    }


    create2FA(username, password) {
        const data = {username: username, password: password, source: 'admin'};
        this.tfaUser = data;

        this.authenticateService.createTfa(data).subscribe(res => {
            if (res.tfa) {
                this.tfa = res.tfa;
            }
        }, error => {
        });
    }

    confirm() {
        this.errorMessage = '';
        this.authenticateService.verifyAuth(this.tfaUser, this.authcode).subscribe((res) => {
            if (res.status) {
                this.currentUser = JSON.parse(localStorage.getItem('user'));
                if (this.currentUser) {
                    this.tfa = {};
                    this.tfaUser = {};
                    this.email.nativeElement.value = '';
                    this.password.nativeElement.value = '';
                    this.openAuthModal.nativeElement.click();
                }
            } else {
                this.errorMessage = 'Güvenlik Kodu Doğrulanamadı';
            }
        }, error => {
            this.errorMessage = 'Güvenlik Kodu Doğrulanamadı';
        });
    }

    disable2Fa(username, password) {
        const data = {username: username, password: password, source: 'admin'};
        this.errorMessageDisable = '';
        this.authenticateService.disableTfaAuth(data, this.onlyAuthCode).subscribe((res) => {
            if (res.status) {
                this.currentUser = JSON.parse(localStorage.getItem('user'));
                if (this.currentUser) {
                    this.onlyAuthCode = '';
                    this.email.nativeElement.value = '';
                    this.password.nativeElement.value = '';
                    this.openAuthModal.nativeElement.click();
                }
            } else {
                this.errorMessageDisable = 'Güvenlik Kodu Doğrulanamadı';
            }
        }, error => {
            this.errorMessageDisable = 'Güvenlik Kodu Doğrulanamadı';
        });
    }

    resetInput() {
        this.currentUser = JSON.parse(localStorage.getItem('user'));
        this.authcode = '';
        this.onlyAuthCode = '';
        this.email.nativeElement.value = '';
        this.password.nativeElement.value = '';
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/layout/authorised/authorised-top-nav/authorised-top-nav.component.ts